import { InstalledSoftware } from "../InstalledSoftware";
import { VersionObfuscator } from "./VersionObfuscator";

export class UpdateVersionInfo extends InstalledSoftware {
    //** Versione disponibile */
    availableVersion: string;

    /** Software aggiornato? */
    isUpToDate: boolean;

    /** Descrizione del pacchetto, usato solo per le custom actions */
    description: string;

    constructor() {
        super();
    }

    get printableAvailableVersion(): string {
        return VersionObfuscator.obfuscate(this.availableVersion);
    }

    public parse(obj: any) {
        super.parse(obj);

        if (obj.AvailableVersion) {
            this.availableVersion = obj.AvailableVersion;
        }

        if (obj.IsUpToDate) {
            this.isUpToDate = obj.IsUpToDate;
        }
        if (obj.Description) this.description = obj.Description;
    }
}
